//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { CuralateCatalogProduct } from '@apis/universal-image-actions/universalImageActionsApiModel';
import { BodyPrimaryAnchor } from '@components/atoms/anchor/Anchor';
import { BodySecondaryText, BodyText } from '@components/atoms/text/Text';
import { UiaProductMedia } from '@uia/products/UiaProductMedia';
import { UiaProductTrackingIds } from '@uia/products/constants/UiaProductConstants';

interface UiaProductItemProps {
  product: CuralateCatalogProduct;
  selectProduct: () => void;
  isSelected: boolean;
  tagSingleProduct: (product: CuralateCatalogProduct) => void;
  isAlreadyTagged: boolean;
}

export const UiaProductItem = ({
  isAlreadyTagged,
  isSelected,
  product,
  selectProduct,
  tagSingleProduct,
}: UiaProductItemProps) => {
  return (
    <div>
      <UiaProductMedia
        isAlreadyTagged={isAlreadyTagged}
        isSelected={isSelected}
        onSelect={selectProduct}
        product={product}
        tagSingleProduct={tagSingleProduct}
      />
      <ProductDetails>
        <BodyText ellipsize={2} title={product.name}>
          {product.name}
        </BodyText>
        {/* // TODO: PD-284075 - Display currency symbol when it is returned from web gateway */}
        <BodySecondaryText title='Price'>{product.price}</BodySecondaryText>
        <BodySecondaryText ellipsize={1} title={product.destinationUrl}>
          <BodyPrimaryAnchor
            href={product.destinationUrl}
            rel='noreferrer'
            target='_blank'
            trackingId={UiaProductTrackingIds.PRODUCT_DESTINATION_URL_LINK}
          >
            {product.destinationUrl}
          </BodyPrimaryAnchor>
        </BodySecondaryText>
      </ProductDetails>
    </div>
  );
};

const ProductDetails = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    padding-top: ${theme.spacings[2]};
    gap: ${theme.spacings[2]};
  `,
);
